export const BREAKPOINT = {
	VERTICAL: 400,
	XS: 480,
	SM: 576,
	MD: 768,
	LG: 992,
	XL: 1366,
	XXL: 1600,
};
